(function () {
  'use strict';

  function getLocale() {
    var html = document.documentElement;
    return (html.lang || html.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function childLabel(review, locale) {
    if (locale === 'fr') {
      return review.child + ', ' + review.age + ' ans';
    }
    return review.child + ', ' + review.age + ' years old';
  }

  function renderCard(review, locale) {
    var comment = locale === 'fr' ? review.comment_fr : review.comment_en;
    if (!comment) return '';

    return (
      '<div class="ted-parent-testimonials__card ted-parent-testimonials__card--featured">' +
      '<blockquote class="ted-parent-testimonials__quote-wrap">' +
      '<span class="ted-parent-testimonials__quote-mark" aria-hidden="true">“</span>' +
      '<p class="ted-parent-testimonials__quote">' +
      escapeHtml(comment) +
      '</p>' +
      '</blockquote>' +
      '<footer class="ted-parent-testimonials__footer">' +
      '<div class="ted-parent-testimonials__author">' +
      '<p class="ted-parent-testimonials__name">' +
      escapeHtml(review.parent) +
      '</p>' +
      '<p class="ted-parent-testimonials__detail">' +
      escapeHtml(childLabel(review, locale)) +
      '</p>' +
      '</div>' +
      '</footer>' +
      '</div>'
    );
  }

  function getViewport(track) {
    return track.querySelector('[data-ted-testimonials-scroll]');
  }

  function getStep(track) {
    var card = track.querySelector('.ted-parent-testimonials__card');
    var carousel = track.querySelector('[data-ted-testimonials-carousel]');
    if (!card) return 320;
    var cardStyle = getComputedStyle(card);
    var margin = parseFloat(cardStyle.marginRight) || 0;
    var gap = carousel ? parseFloat(getComputedStyle(carousel).gap) || 0 : 0;
    return card.offsetWidth + Math.max(margin, gap);
  }

  function getMaxScroll(viewport) {
    if (!viewport) return 0;
    return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
  }

  function updateButtons(track, viewport) {
    var prevBtn = track.querySelector('[data-ted-testimonials-prev]');
    var nextBtn = track.querySelector('[data-ted-testimonials-next]');
    var maxScroll = getMaxScroll(viewport);
    var offset = viewport ? viewport.scrollLeft : 0;

    if (prevBtn) prevBtn.disabled = offset <= 1;
    if (nextBtn) nextBtn.disabled = offset >= maxScroll - 1;
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initAutoScroll(track, viewport) {
    var carousel = track.querySelector('[data-ted-testimonials-carousel]');
    if (!carousel || prefersReducedMotion()) return null;

    var originalHTML = carousel.innerHTML;
    var loopWidth = 0;
    var speed = 0.35;
    var scrollAccumulator = 0;
    var isHovered = false;
    var userInterrupted = false;
    var rafId = null;
    var running = false;

    function normalizeScrollPosition() {
      if (loopWidth <= 0) return;
      if (viewport.scrollLeft >= loopWidth) {
        viewport.scrollLeft -= loopWidth;
      }
    }

    function tick() {
      if (running && !userInterrupted && !isHovered) {
        scrollAccumulator += speed;
        if (scrollAccumulator >= 1) {
          var step = Math.floor(scrollAccumulator);
          scrollAccumulator -= step;
          normalizeScrollPosition();
          viewport.scrollLeft += step;
          normalizeScrollPosition();
          updateButtons(track, viewport);
        }
      }

      rafId = window.requestAnimationFrame(tick);
    }

    function start() {
      if (running) return;
      running = true;
      if (!rafId) {
        rafId = window.requestAnimationFrame(tick);
      }
    }

    function prepareLoop() {
      carousel.innerHTML = originalHTML + originalHTML;
      loopWidth = carousel.scrollWidth / 2;
      return getMaxScroll(viewport) > 0 && loopWidth > 0;
    }

    function boot() {
      if (!prepareLoop()) return false;
      start();
      return true;
    }

    track.addEventListener('mouseenter', function () {
      isHovered = true;
    });

    track.addEventListener('mouseleave', function () {
      isHovered = false;
    });

    var touchStartX = 0;
    var touchStartY = 0;

    viewport.addEventListener(
      'touchstart',
      function (event) {
        if (!event.touches.length) return;
        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      },
      { passive: true }
    );

    viewport.addEventListener(
      'touchmove',
      function (event) {
        if (!event.touches.length || userInterrupted) return;
        var deltaX = Math.abs(event.touches[0].clientX - touchStartX);
        var deltaY = Math.abs(event.touches[0].clientY - touchStartY);
        if (deltaX > 8 && deltaX > deltaY) {
          userInterrupted = true;
        }
      },
      { passive: true }
    );

    viewport.addEventListener(
      'scroll',
      function () {
        updateButtons(track, viewport);
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      loopWidth = carousel.scrollWidth / 2;
      normalizeScrollPosition();
      updateButtons(track, viewport);
    });

    if (!boot()) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          boot();
        });
      });
    }

    return function destroy() {
      running = false;
      if (rafId) window.cancelAnimationFrame(rafId);
    };
  }

  function initTrack(track) {
    var viewport = getViewport(track);
    var prevBtn = track.querySelector('[data-ted-testimonials-prev]');
    var nextBtn = track.querySelector('[data-ted-testimonials-next]');

    if (!viewport || !prevBtn || !nextBtn) return;

    var scrollByStep = function (direction) {
      viewport.scrollBy({
        left: getStep(track) * direction,
        behavior: 'smooth',
      });
    };

    prevBtn.addEventListener('click', function (event) {
      event.preventDefault();
      scrollByStep(-1);
    });

    nextBtn.addEventListener('click', function (event) {
      event.preventDefault();
      scrollByStep(1);
    });

    window.addEventListener('resize', function () {
      updateButtons(track, viewport);
    });

    updateButtons(track, viewport);
    initAutoScroll(track, viewport);
  }

  function loadReviews(track) {
    var carousel = track.querySelector('[data-ted-testimonials-carousel]');
    var dataEl = document.querySelector('[data-ted-reviews-data]');
    if (!carousel || !dataEl) return;

    var url = dataEl.getAttribute('data-ted-reviews-data');
    var locale = getLocale();

    fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var reviews = data.reviews || [];
        if (!reviews.length) {
          carousel.innerHTML = '';
          return;
        }

        carousel.innerHTML = reviews
          .map(function (review) {
            return renderCard(review, locale);
          })
          .join('');

        initTrack(track);
      })
      .catch(function () {
        carousel.innerHTML = '';
      });
  }

  function init() {
    document.querySelectorAll('[data-ted-testimonials-track]').forEach(loadReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
